import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { Env } from '../env';
import { Observable } from 'rxjs/Observable';
import { Permission } from '../models/permission';
import { ContractListItemSource } from '../models/contractListItemSource';
import { ContractSource } from '../models/contractSource';
import { observableToBeFn } from 'rxjs/testing/TestScheduler';
import { splitStringBySize } from '@firebase/database/dist/esm/src/core/util/util';

@Injectable()
export class TenantService {

    constructor(private http: HttpClient, private global: Env) { }

    getAll( page:number = 0 , dni:string = "" , email:string = "" , lastName:string = ""  , name:string = "", status:boolean = true , size:number = 10):Observable<ContractListItemSource[]>{
      let filtro = "";

      if ( dni > "" ){
        filtro += "&dni="+dni;
      }
      if ( email > "" ) {
        filtro += "&email="+email;
      }
      if ( lastName > "" ){
        filtro += "&lastName="+lastName;
      }
      if ( name > "" ) {
        filtro += "&name="+name;
      }

      const url = this.global.tenant+'/search?&page='+page+filtro+'&status='+status+'&size='+size;
      console.log(url);
      return this.http.get(url).map((res: ContractListItemSource[]) => {
        return res;
      });
    }

    get(id):Observable<any> {
      const url = this.global.tenant+'/'+id;

      return this.http.get(url).map((res: any) => {
        return res;
      });
    }

}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/services/tenant.service.ts